// BidHistory.js
import React from "react";
import "./BidHistory.css";
import { useSelector,useDispatch } from "react-redux";
import { get_all_depends } from "../features/userSlice";

const AccountHistory = () => {
    const { isUserLogedIn,Info,Wallet_history } = useSelector((state) => state.users);
    const dispatch=useDispatch();
    React.useEffect(()=>{
  console.log('CALL_ONE');

      if(isUserLogedIn){
        let data = new FormData();
        data.append('phone_number',Info?.phone_number);
        dispatch(get_all_depends({request_type:'get_wallet_history',data:data}));
      }
     },[isUserLogedIn])

     const refine_amount=(transAmount,updatedAmount,TYEP,remark)=>{
              // Remove '+' or '-' sign and convert to number
              const transactionAmount = parseFloat(transAmount.replace(/[+-]/g, ''));

              // Determine the sign of the transaction
              const isDeposit = transAmount.startsWith('+');
           if(TYEP==='TAG'){
               if(isDeposit || remark==='Welcome Bonus'){
                let remarksss=remark==='Welcome Bonus'?'+':'';
                return <span style={{color:'green'}}>{`${remarksss}${transAmount}`}</span> ;
               }else{
                return <span style={{color:'red'}}>{`-${transAmount}`}</span> ;
               }
           } 

              // Calculate previous amount based on transaction type
              if (isDeposit || remark==='Welcome Bonus') {
              return parseInt(updatedAmount) - transactionAmount;
              } else {
              return parseInt(updatedAmount) + transactionAmount;
              }
     }


     function formatDate(dateString) {
      const date = new Date(dateString);
      const options = { day: 'numeric', month: 'short', year: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    }

  return (
    <div className="">
      <div className="table-wrapper">
        <table className="bid-history-table">
          <thead className="tbl_head">
            <tr>
              <th>Trans. date</th>
              <th>Perticular</th>
              <th>Previous Amount</th>
              <th>Transaction Amount</th>
              <th>Current Amount</th>
            </tr>
          </thead>
          <tbody>
            {Wallet_history.map((bid, index) => (
              <tr key={index}>
                <td>{formatDate(bid.date)}</td>
                <td>{bid.remark}</td>
                <td>{refine_amount(bid.amount,bid.updated_amount,'CAL',bid.remark)}</td>
                <td>{refine_amount(bid.amount,bid.updated_amount,'TAG',bid.remark)}</td>
                <td>{bid.updated_amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <br/><br/><br/>
    </div>
    
  );
};

export default AccountHistory;
